import React from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Row, Col, Table } from "reactstrap";
import formations from "../../CommonData/Data/formation";
import OverViewStep from "./OverViewStep";

const FormationDetail = () => {
    const { id } = useParams();
    const formation = formations?.find((f) => f.id === parseInt(id, 10)); // Vérifie si formations est défini

    if (!formation) {
        return (
            <Container>
                <h2>Formation introuvable</h2>
            </Container>
        );
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>


                    <h1> {formation.nom}</h1>
                    <p><strong>Score :</strong> {formation.score}</p>
                    <br />
                    <OverViewStep userlvl={4} />
                    <h3>Stages </h3>
                    <br />
                    {Array.isArray(formation.stages) && formation.stages.length > 0 ? (
                        <Row>
                            <Col lg={5}>
                                <Table className="table table-centered table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>Nom</th>
                                            <th>Steps</th>
                                            <th>Score </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formation.stages.map((stage) => (
                                            <tr key={stage.id}>
                                                <td>{stage.nom}</td>
                                                <td>
                                                    <Link to={`/step/${stage.id}`} className="btn btn-primary">
                                                        Voir les steps
                                                    </Link>
                                                </td>
                                                <td>{formation.score}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    ) : (
                        <p>Aucun chapitre trouvé</p>
                    )}

                </Container>
            </div>
        </React.Fragment>
    );
};
export default FormationDetail;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license